import { EventEmitter, Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { AuthService } from "../core-services/services/auth.service";
import { CrossAppAuthService } from "../core-services/services/cross-app-auth.service";
import { SsoRedirectService } from "../core-services/services/sso-redirect.service";

@Injectable()
export class MenuService {
  list1Event: EventEmitter<any> = new EventEmitter();
  list2Event: EventEmitter<any> = new EventEmitter();
  openMenu: EventEmitter<string> = new EventEmitter();

  public closeSideNavAfterNavigation = new BehaviorSubject(true);
  public closeSideNavAfterNavigation$ = this.closeSideNavAfterNavigation.asObservable();

  constructor(
    private authService: AuthService,
    private crossAppAuth: CrossAppAuthService,
    private ssoRedirect: SsoRedirectService
  ) { }

  getAll(): any {
    const userMenu: Array<{
      sso?: string;
      label: string;
      icon: string;
      tooltip: string;
      link?: string;
      isSubMenu?: boolean;
      isDraggable?: boolean;
      heap_id?: string;
      sublink?: string;
      sublink_two?: string;
      sublink_three?: string;
    }> = [
        {
          link: "/flyboard",
          label: "FlyBoard",
          icon: "icon-ico-dashboard",
          tooltip:
            "FlyBoard aka Dashboard displays top FlyMSGs used along with individual cost and time savings statistics.",
        },
        {
          sublink: "/shortcuts",
          label: "FlyCuts",
          icon: "icon-ico-shortcut",
          tooltip: "FlyCuts aka Shortcuts displays the library of your messages and templates saved.",
          isSubMenu: true,
          isDraggable: true,
        },
        {
          sublink: "/flyplates",
          label: "FlyPlates",
          icon: "icon-ico-template",
          tooltip: "FlyPlates aka Templates. Based on your plan type, you have access to some or all of them.",
          heap_id: "flyplates",
          isSubMenu: true,
        },
        {
          sublink: "/flyshare",
          label: "FlyShare",
          icon: "icon-ico-share",
          tooltip:
            "FlyShare is your sharing center that allows you to easily manage and access all FlyMSGs you've shared or received.",
          isSubMenu: true,
        },
      ];

    if (this.ssoRedirect.hasRoleplayAccess) {
      userMenu.push({
        sso: "roleplay",
        label: "RolePlay",
        icon: "icon-ico-dashboard",
        tooltip:
          "Click here to practice doing cold calls and discovery calls with your customer personas using AI. We'll create up to 16 AI buyers, one for each of 16 buyer personality types, for you to practice with based on your ICP, industry, buyer type, or other ideas you come up with.",
      });
    }

    userMenu.push({
      sso: "flylearning",
      label: "FlyLearning",
      icon: "icon-ico-dashboard",
      tooltip:
        "FlyLearning is our on-demand learning library of over 14 hours of sales prospecting education available only with a Business Pro Individual or Teams license.",
    });

    if (!this.authService.showAdminSection() && !this.authService.showVengresoAdminSection()) {
      return userMenu;
    }

    const userRoles = this.authService.getUserRole();
    let adminLink = "/";
    let cmcAdminLink = "/";
    let isAdminExternal = false;
    let isCmcExternal = false;

    if (userRoles.includes("Vengreso Admin")) {
      // For CMC admin, check if we should use external URL (when in main app)
      if (this.crossAppAuth.isMainApp) {
        // Redirect to the root domain as specified in CMC_APP_DOMAIN
        cmcAdminLink = this.crossAppAuth.cmcAppDomain;
        isCmcExternal = true;
      } else {
        cmcAdminLink = "/cmc";
      }
    }

    if (userRoles.some((role) => ["Global Admin", "Reporting Admin", "Group Admin"].includes(role))) {
      const companySlug = this.authService.getUserCompanySlug();
      // For company admin, check if we should use external URL (when in main app)
      if (this.crossAppAuth.isMainApp) {
        // Redirect to the root domain as specified in ADMIN_APP_DOMAIN
        adminLink = this.crossAppAuth.adminAppDomain;
        isAdminExternal = true;
      } else {
        adminLink = "/admin";
      }
    }

    const adminMenu = [
      {
        sublink: "/settings",
        sublink_two: adminLink,
        sublink_three: cmcAdminLink,
        label: "Administration",
        icon: "icon-admin-menu",
        tooltip: "Access and manage users, groups and reporting.",
        isSubMenu: true,
        // Mark if links are external (for cross-app navigation)
        isAdminExternal,
        isCmcExternal,
      },
    ];

    return [...userMenu, ...adminMenu];
  }
}
